<template>
  <v-card class="room-card" elevation="1">
    <v-layout class="pa-3 d-flex row" style="height: 100%;" row wrap>
      <v-flex class="mb-auto" xs12>
        <div class="subheading font-weight-bold primary--text text-truncate" :title="roomName">{{ roomName }}</div>
        <div class="body-2 mt-1 grey--text text--darken-2">
          <v-icon small class="mr-1">restaurant</v-icon>
          {{ boardName }}
        </div>

        <v-divider class="my-2"></v-divider>

        <div class="caption red--text text--darken-2" v-if="offer.CancellationPolicy">
          <v-icon small color="red darken-2">info</v-icon>
          {{ offer.CancellationPolicy }}
        </div>
      </v-flex>

      <v-layout class="mt-3" xs12 row wrap>
        <v-flex xs12 sm6 md6 class="title success--text font-weight-bold mb-3 xs6">{{ offer.ServicePrice }} {{ offer.CurrencyType }}</v-flex>
        <v-flex>
                <v-btn xs12 sm3 md3 color="success" block depressed class="ma-0 xs3" @click="selectRoom" :loading="allocating" :disabled="allocating">{{ $t('Hotel-Select-Room-Button') }}</v-btn>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-card>
</template>

<script>
import auth from '@/api/auth.js';

export default {
  name: 'HotelRoomCard',
  props: {
    offer: {
      type: Object,
      required: true
    },
    hotel: {
      type: Object,
      default: null
    },
    sessionHeader: {
      type: Object,
      default: null
    },
    searchParams: {
      type: Object,
      default: () => ({})
    },
    searchId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      allocating: false
    };
  },
  computed: {
    roomInfo() {
      return this.offer.Rooms && this.offer.Rooms.length > 0 ? this.offer.Rooms[0] : {};
    },
    roomName() {
      return this.roomInfo.roomName || this.$t('Hotel-Unknown-Room');
    },
    boardName() {
      return this.roomInfo.boardName || '';
    }
  },
  methods: {
    selectRoom() {
      if (!this.sessionHeader) {
        this.$emit('error', { type: 'error', message: this.$t('Hotel-Session-Info-Not-Found') });
        return;
      }
      const locale = this.$i18n.locale || 'tr';
      const cultureCodes = { 'tr': 'tr-TR', 'en': 'en-US', 'de': 'de-DE', 'fr': 'fr-FR' };
      const currentCulture = cultureCodes[locale] || locale;
      this.allocating = true;
      const allocateParams = {
        SessionHeader: this.sessionHeader,
        RateId: this.hotel.RateId || this.hotel.HotelId,
        RateName: this.roomInfo.roomName || "Room",
        ShoppingCartId: null,
        Language: "tr",
        StartDate: this.searchParams.startDate ? new Date(this.searchParams.startDate + 'T00:00:00').toISOString() : new Date().toISOString(),
        EndDate: this.searchParams.endDate ? new Date(this.searchParams.endDate + 'T00:00:00').toISOString() : new Date().toISOString(),
        MarkupType: 0,
        MarkupPrice: 0,
        CurrencyType: this.searchParams.currency || "TRY",
        GroupByHotel: 0,
        LogInput: null,
        OfferId: this.offer.OfferId || "",
        CancellationPolicy: this.offer.CancellationPolicy || null,
        PassengersInfo: this.searchParams.rooms ? this.searchParams.rooms.map((r, i) => ({
          RoomId: i + 1,
          Adt: r.adults,
          Child: r.children,
          ChildAge: (r.childAges && r.childAges.length > 0) ? r.childAges : null
        })) : [{ RoomId: 1, Adt: 2, Child: 0, ChildAge: null }],
        SearchId: this.searchId,
        Culture: currentCulture,
      };

      this.$http.post(auth.BOOKING_API_URL + "Hotel/Allocate", allocateParams, {
        headers: { Authorization: "Bearer " + auth.getAuthHeader() }
      }).then(
        (response) => {
          if (!response.body.HasError && response.body.ShoppingCart) {
            window.localStorage.setItem("shopCartID", response.body.ShoppingCart.Id);
            window.localStorage.setItem("bookingParams", JSON.stringify(this.sessionHeader));
            this.$router.push({
              path: '/satis/otel/islem',
              query: { islem: 'new', cartId: response.body.ShoppingCart.Id }
            });
          } else {
            const errorMsg = (response.body.ServiceError && response.body.ServiceError.ErrorMessages && response.body.ServiceError.ErrorMessages[0]) || this.$t('Hotel-Allocation-Failed');
            this.$emit('error', { type: 'error', message: errorMsg });
            this.allocating = false;
          }
        },
        (error) => {
          this.$emit('error', { type: 'error', message: this.$t('Hotel-Allocation-Service-Error') });
          this.allocating = false;
        }
      );
    }
  }
}
</script>

<style scoped>
.room-card {
  height: 100%;
  border-radius: 8px;
  border: 1px solid #eee;
  transition: all 0.2s ease-in-out;
}

.room-card:hover {
  border-color: #1976D2;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.15) !important;
}
</style>
